// extracted by mini-css-extract-plugin
module.exports = {"logo":"Mainpage_logo__KR68y","but":"Mainpage_but__29fZU","name":"Mainpage_name__EcS5Y","card":"Mainpage_card__28Tus"};